module.exports = __webpack_public_path__ + "files/b1a3ad1274b1da86f05afe63f9e71fd6.png";